import React from 'react';
import { LazyImage } from 'shared/components/LazyImage';
import * as styles from './styles.css';
import phoneImage from './assets/phone.png';
import { BLOCK_SOURCES } from './constants';
import { TDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

interface IAdPositionBlocksProps {
  device: TDeviceType;
  setBlockRef: (blockIndex: number) => (node: HTMLDivElement | null) => void;
}

export const AdPositionBlocks: React.FC<IAdPositionBlocksProps> = ({ setBlockRef, device }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <LazyImage
        src={phoneImage}
        alt=""
        loaderColor="white_100"
        wrapperLoadingClassName={styles['image-loading']}
        wrapperClassName={styles['image']}
      />
      <div className={styles['blocks']}>
        {BLOCK_SOURCES.map((src, blockIndex) => (
          <div key={blockIndex} ref={setBlockRef(blockIndex)} className={styles['block-wrapper']}>
            <LazyImage
              src={src}
              alt={`объявление ${blockIndex + 1}`}
              loaderColor="white_100"
              wrapperClassName={styles['block']}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
